/**
 * Ray Note
 * 
 * Do not add stuff here,
 * we should move this to a service so that it becomes globally available
 * 
 * What is happening right now is we have to invoke `setSettingsMap` again and again for every
 * component or class that needs to use this impl
 * 
 * A better approach is to convert this to service, invoke setSettingsMap only once (pref on pages.component) * 
 */
export class Settings {
  loaOrContract: boolean | undefined;
  incomingDrCancelFileSizeLimit: number | undefined;
  labelSerialCode: string | undefined;
  showContract: boolean | undefined;

  constructor() {
    this.loaOrContract = undefined;
    this.incomingDrCancelFileSizeLimit = undefined;
    this.labelSerialCode = undefined;
    this.showContract = undefined;
  }

  setLoaOrContract(value: boolean) {
    this.loaOrContract = value;
  }

  getLoaOrContract(): boolean | undefined {
    return this.loaOrContract;
  }

  setShowContract(value: boolean) {
    this.showContract = value;
  }

  getShowContract(): boolean | undefined {
    return this.showContract;
  }

  setIncomingDrCancelFileSizeLimit(value: number) {
    this.incomingDrCancelFileSizeLimit = value;
  }
  
  getIncomingDrCancelFileSizeLimit(): number | undefined {
    return this.incomingDrCancelFileSizeLimit;
  }

  setLabelSerialCode(value: string) {
    this.labelSerialCode = value;
  }

  getLabelSerialCode(): string | undefined {
    return this.labelSerialCode;
  }

  setSettingsMap(value: string) {
    const parsed = JSON.parse(value);
    this.loaOrContract = parsed?.loa_or_contract;
    this.incomingDrCancelFileSizeLimit = parsed?.incoming_dr_cancel_file_size_limit;
    this.labelSerialCode = parsed?.label_serial_code;
    this.showContract = parsed?.show_contract_maintenance;
  }
}